/**=========================================================
 * Module: reports.js
 * Reports Controller
 =========================================================*/

App.controller('ReportsController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) {
    "use strict";

    $scope.type = 'project';
    $scope.filter = 'statusgroup=reports&_type=reports';

    $scope.data = [];

    $scope.page = {
            title: 'sidebar.heading.REPORTS',
            subTitle: ''
        };

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

        if($rootScope.user.id && $rootScope.user.groupType!='SUPPLIER'){
            $scope.initialized = true;

            $scope.table = {
                title: '',
                filter: true,
                cls: 'no-panel-table',
                type: 'project',
                includedFields: ['id'],
                baseFilter: $scope.filter,
				containerStyle: {'min-height': '600px'},
                fields: [
                    {
                    	available: $rootScope.user.groupType=='SUPPLIER' || $rootScope.user.admin,
                        name: 'groupName',
                        filterType: 'clients',
                        filterValue: '',
                        orderable: true
                    },{
                    	available: true,
                        hasLink: true,
                        name: 'code',
                        label: 'PROJECTCODE',
                        filterType: 'text',
                        filterValue: '',
                        orderable: true,
                        compareType: 'projectCode',
                        style: {
                            'white-space': 'nowrap'
                        }
                    },{
                    	available: true,
                        hasLink: true,
                        name: 'name',
                        label: 'PROJECTNAME',
                        filterType: 'text',
                        filterValue: '',
                        orderable: true,
						style: {
							width: '400px'
						}
                    },{
                    	available: true,
                        name: 'status',
                        label: 'PROJECTSTATUS',
                        type: 'enum',
                        enumType: 'status',
                        filterType: 'select',
                        filterOptions: [
                                        {value:'', label:''},
                                        {value:"DRAFT", label:'enums.status.DRAFT'},
                                        {value:"SENT", label:'enums.status.SENT'},
                                        {value:"ANALYSIS", label:'enums.status.ANALYSIS'},
                                        {value:"REVISION", label:'enums.status.REVISION'},
                                        {value:"ESTIMATION", label:'enums.status.ESTIMATION'},
                                        {value:"CONFIRMED", label:'enums.status.CONFIRMED'},
                                        {value:"PROCESSING", label:'enums.status.PROCESSING'},
                                        {value:"DELIVERED", label:'enums.status.DELIVERED'},
                                        {value:"STOPPED", label:'enums.status.STOPPED'},
                                        {value:"ARCHIVED", label:'enums.status.ARCHIVED'}
                                        ],
                        style: {
                            'white-space': 'nowrap'
                        }
                    },{
                    	available: true,
                        name: 'delivery',
                        type: 'date',
                        filterType: 'date',
                        filterValue: '',
                        orderable: true
                    },{
                    	available: true,
                        name: 'source',
                        type: 'enum',
                        enumType: 'language',
                        filterType: 'language',
                        filterValue: '',
						style: {
							'min-width': '200px'
						}
                    },{
                    	available: true,
                        name: 'destinations',
                        type: 'enumSet',
                        enumType: 'language',
                        filterType: 'multilanguage',
                        filterValue: '',
						style: {
							'min-width': '300px'
						}
                    },{
                    	available: true,
                        name: 'supplierName',
                        filterType: 'suppliers',
                        filterValue: ''
                    },{
                    	available: $rootScope.user.groupType=='SUPPLIER',
                    	name: 'offerSent',
                    	type: 'boolean'
                    }
                ],
                link: {
                	state: 'app.entity',
                	action: 'report',
                    type: 'project',
                    filter: 'id'
                },
                loading: true
            };


        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();

    $scope.$on('$destroy', function iVeBeenDismissed() {
      // say goodbye to your controller here
      // release resources, cancel request...
      $scope.load = function() { };
    });
}]);
